// Three-way theme support: "system" | "light" | "dark".
// "system" follows the OS via prefers-color-scheme and is the default when
// nothing is stored. Keep this module dependency-free so it can be reused from
// the store, the error/404 screens, and (in spirit) the pre-paint script in
// index.html.

export const THEME_KEY = "theme";

/** @typedef {"system" | "light" | "dark"} ThemeMode */
export const THEME_MODES = ["system", "light", "dark"];

/** Does the OS currently prefer a dark appearance? */
export const systemPrefersDark = () =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia("(prefers-color-scheme: dark)").matches;

/** Read the saved preference, defaulting to "system". */
export const getStoredTheme = () => {
  try {
    const stored = localStorage.getItem(THEME_KEY);
    return THEME_MODES.includes(stored) ? stored : "system";
  } catch {
    return "system";
  }
};

/** Resolve a preference to the effective appearance ("light" | "dark"). */
export const resolveIsDark = (theme = getStoredTheme()) =>
  theme === "dark" || (theme === "system" && systemPrefersDark());

/** Toggle the `dark` class on <html> to match the given preference. */
export const applyTheme = (theme = getStoredTheme()) => {
  document.documentElement.classList.toggle("dark", resolveIsDark(theme));
};
